// wrapper for the public Moonbase.js API
// some of these types are duplicated in the Moonbase.js library, eventually we should consolidate them somehow (once we ship Moonbase.js as a package)

type Moonbase = {
  config: {
    hcaptchaSiteKey: string;
  };
  forms: {
    executeSubmit: (
      formData: FormData,
      formId: string,
    ) => Promise<
      | {
          type: "success";
          redirectUrl?: string;
        }
      | {
          type: "validation_error";
          validationErrors: ValidationErrors;
        }
      | {
          type: "unexpected_error";
          error: Error;
        }
    >;
    getForm: (id: string) => Form;
  };
  captcha: {
    executeCaptcha: (
      formData: FormData,
      siteKey: string,
      widgetId: string,
    ) => Promise<{ type: "success" } | { type: "error" }>;
    renderCaptcha: (props: { container: HTMLElement; siteKey: string }) => string;
  };
  normalize: {
    normalizeUrl: (input: string) => string | null;
  };
};

type ValidationErrors = Record<string, string[]>;

type FormField = {
  id: string;
  key: string;
  name: string;
  description: string | null;
  cardinality: "one" | "many";
} & (
  | {
      type: "choice";
      options: { id: string; label: string; color: string }[];
    }
  | {
      type: "text";
      subType: "single_line" | "multi_line";
    }
  | {
      type: "email" | "telephone_number" | "geo" | "boolean" | "date" | "datetime";
    }
  | {
      type: "uri";
      subType: "url" | "domain" | "social_x" | "social_linked_in";
    }
  | {
      type: "number";
      subType: "unitless_integer" | "monetary" | "unitless_float" | "percentage";
    }
);

type Form = {
  id: string;
  schema: {
    name: string;
    description: string | null;
    validations: Record<string, string[]>;
    fields: FormField[];
  };
};

// @ts-expect-error the Moonbase.js should always be loaded first
const moonbase: Moonbase = globalThis.__MOONBASE__;

if (!moonbase) {
  throw new Error("Moonbase.js not loaded");
}

export { moonbase, type FormField, type Form };
